import React, { useState, useEffect, useRef } from 'react';
import { useAppDispatch, useAppSelector } from '../../../../redux/hooks';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

// Components 

import Box from '@mui/material/Box';
import DataBox from '../../../general/data/DataBox';
import DataRow from '../../../general/data/DataRow';

import TodayIcon from '@mui/icons-material/Today';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import EventNoteIcon from '@mui/icons-material/EventNote';
import QueryBuilderIcon from '@mui/icons-material/QueryBuilder';
import WorkspacesIcon from '@mui/icons-material/Workspaces';
import { getDoctorDataUsage } from '../../../../routes/hacker/users';
import CalendarViewMonthIcon from '@mui/icons-material/CalendarViewMonth';
import CalendarViewWeekIcon from '@mui/icons-material/CalendarViewWeek';

interface Props { 

}; 

const DoctorUsage: React.FC<Props> = ({ }) => {

    const dispatch = useAppDispatch(); 
    const { t } = useTranslation(); 
    const navigate = useNavigate(); 

    const colors = useAppSelector(state => state.theme.colors); 

    const selectedDoctor = useAppSelector(state => state.doctorsAccess.selectedDoctor); 

    const [usage, setUsage] = useState(null) as any; 

    // -- 

    const handleDataUsage = async () => { 

        const res = await getDoctorDataUsage(selectedDoctor._id) as any;  

        if (res.data?.status === 200) { 

            setUsage(res.data); 

        }; 


    }; 

    // -- 

    useEffect(() => { 

        if (selectedDoctor) { 

            handleDataUsage(); 

        }; 

    },[selectedDoctor]); 

    return (

        <DataBox title='Consultation Notes'>

            <DataRow icon={<WorkspacesIcon sx={{ color: colors?.main }} />} title={'Usage Ratio'} data={usage?.notes?.usageRatio} />

            <DataRow  icon={<QueryBuilderIcon sx={{ color: 'rgb(199, 118, 42)' }} />} title={'Last Hour'} data={usage?.notes?.lastHour} />

            <DataRow  icon={<TodayIcon sx={{ color: 'rgb(172, 101, 34)' }} />} title={'Last Day'} data={usage?.notes?.lastDay} />

            <DataRow  icon={<CalendarViewMonthIcon sx={{ color: 'rgb(172, 101, 34)' }} />} title={'Last 3 Days'} data={usage?.notes?.last3Days} />

            <DataRow  icon={<CalendarViewWeekIcon sx={{ color: 'rgb(172, 101, 34)' }} />} title={'Last Week'} data={usage?.notes?.lastWeek} />

            <DataRow  icon={<CalendarMonthIcon sx={{ color: 'rgb(146, 86, 29)' }} />} title={'Last Month'} data={usage?.notes?.lastMonth} />

            <DataRow  icon={<EventNoteIcon sx={{ color: 'rgb(99, 58, 21)' }} />} title={'Total'} data={usage?.notes?.total} />

        </DataBox> 
                
  );

};

export default DoctorUsage;